import 'react-image-gallery/styles/css/image-gallery.css';
import { ReactImageGalleryProps } from 'react-image-gallery';

import { HotelDetailVideoViewModel } from '@api/v3';
import {
  HotelDetailAnnouncementViewModel,
  HotelDetailViewModel,
  RoomViewModel,
} from '@api/index';

type FeatureElement = Partial<{
  name: string;
  hasCharged: boolean;
  id: number;
}>;
export type HotelFeatureGroup = {
  id: number;
  description?: string;
  name?: string;
  features: FeatureElement[];
};

export type Entity = 'room' | 'hotel' | undefined;

type EntityFeature<E extends Entity, F> = {
  entityType: NonNullable<E>;
  features: F;
};

export type HotelFeaturesMeta = EntityFeature<'hotel', HotelFeatureGroup[]>;
export type RoomFeaturesMeta = EntityFeature<'room', FeatureElement[]>;
export type EitherRoomOrHotelFeaturesMeta =
  | HotelFeaturesMeta
  | RoomFeaturesMeta;

export type DetailsGalleriesModalProps = Omit<
  ReactImageGalleryProps,
  'items'
> & {
  galleries: { [key: string]: ReactImageGalleryProps['items'] };
  title?: string;
  closeModal?: () => void;
  price?: HotelDetailViewModel['lowestPrice'] & { roomInformation?: string };
  adultsCount?: number;
  childrenCount?: number;
  nightsCount?: number;
  buttonActionMessage: string;
  isOpen: boolean;
  view: ModalView;
  room?: RoomViewModel;
  announcements?: HotelDetailAnnouncementViewModel[] | undefined;
  className?: string;
  activeGalleryModalName?: string;
  startImage: number;
  videos?: HotelDetailVideoViewModel[];
  control?: boolean;
} & EitherRoomOrHotelFeaturesMeta;

export enum ModalView {
  GALLERIES = 'galleries',
  DETAILS = 'details',
  NONE = 'none',
}
